import { useState, useEffect, useRef } from "react";
import "./SwitchSelect.css";

function SwitchSelect({ value, onChange, options = [], labels = null }) {
  const containerRef = useRef(null);
  const [highlightStyle, setHighlightStyle] = useState({});

  useEffect(() => {
    const idx = options.indexOf(value);
    if (containerRef.current && idx !== -1) {
      const btn = containerRef.current.querySelectorAll("button")[idx];
      if (btn) {
        setHighlightStyle({
          width: btn.offsetWidth + "px",
          transform: `translateX(${btn.offsetLeft}px)`,
        });
      }
    }
  }, [value, options]);

  return (
    <div className="switch-select" ref={containerRef}>
      <div className="switch-highlight" style={highlightStyle}></div>
      {options.map((opt) => (
        <button
          key={opt}
          type="button"
          className={`switch-button switch-option ${value === opt ? "active" : ""}`}
          onClick={() => onChange(opt)}
        >
          {labels?.[opt] ?? opt}
        </button>
      ))}
    </div>
  );
}

export default SwitchSelect;
